import { Link, useNavigate } from 'react-router-dom'
import CommunityCTA from '../shared/CommunityCTA'
import SubscribeBox from '../email/SubscribeBox'
import { openPrivacyChoices } from '../../lib/ads'
import LanguageSwitcher from './LanguageSwitcher'
import { useCommonT } from '../../i18n'

export default function Footer() {
  const navigate = useNavigate()
  const t = useCommonT()
  return (
    <>
    {/* The one SPA-wide subscribe placement. Narrow and low-contrast on
        purpose: it sits under every route, so anything louder would read as a
        nag rather than an offer. */}
    <div className="pt-10 max-w-md mx-auto px-4">
      <SubscribeBox source="footer" compact />
    </div>
    {/* flex-wrap is load-bearing on a phone: eight links in one unwrapped
        row measured 416px on a 390px screen, and a mobile browser answers
        page overflow by WIDENING the layout viewport, which then shoves
        every fixed element (bottom nav, Deck Chat pill, tool sheets) past
        the right edge of the glass.
        The bottom padding below md is the scroll-end clearance for the fixed
        MobileNav, which rides on --ad-inset-bottom above a Mediavine
        adhesion ad when one is present (src/lib/adInset.ts) and carries the
        safe-area inset, so both are added to the 6rem here. While nav v2's
        floating Scan button is on screen it reaches higher than that, and it
        publishes its own footprint as --fab-clearance (ScanFab.tsx), and the
        collapsed Deck Chat pill does the same as --chat-pill-clearance
        (DeckChatDock.tsx); the padding is the largest of the three. md+
        unchanged.
        `site-footer` is a hook, not a style: the Journey dashboard's Footer
        Selector, the same class the blog and guide shell's footer carries
        (scripts/blog-lib.mjs). Keep it unique on the page. */}
    <footer className="site-footer pb-[max(calc(6rem+env(safe-area-inset-bottom,0px)+var(--ad-inset-bottom,0px)),var(--fab-clearance,0px),var(--chat-pill-clearance,0px))] md:pb-6 pt-8 text-center text-xs text-gray-500 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 px-4">
      <Link to="/support" className="hover:text-gray-300 transition-colors">{t('footer.support')}</Link>
      {/* A plain <a>, not <Link>: /switch/* are prerendered static pages
          (scripts/prerender-switch.mjs) that the SPA router has no route for. */}
      <a href="/switch/manabox" className="hover:text-gray-300 transition-colors">{t('footer.switch_manabox')}</a>
      {/* Inline variant: the footer renders on every route, so an impression
          event here would bill a row per page view for a number nothing reads. */}
      {/* eslint-disable-next-line i18next/no-literal-string -- brand name */}
      <CommunityCTA placement="footer" variant="inline" label="Discord" />
      <Link to="/terms" className="hover:text-gray-300 transition-colors">{t('footer.terms')}</Link>
      <Link to="/privacy" className="hover:text-gray-300 transition-colors">{t('footer.privacy_policy')}</Link>
      {/* Reopens Mediavine's consent dialog so EU/UK visitors can change
          their choice. Always rendered: the wrapper is static in the shell,
          there is no build flag to hide behind. When no CMP API is on the
          window (blocked, not loaded, or a visitor outside the consent
          regions) the click lands on the privacy policy instead, because a
          footer control that silently does nothing is a bug, not a fallback. */}
      <button
        type="button"
        onClick={() => {
          void openPrivacyChoices().then((opened) => {
            if (!opened) navigate('/privacy')
          })
        }}
        className="hover:text-gray-300 transition-colors"
      >
        {t('footer.privacy_choices')}
      </button>
      {/* Interface language. Renders nothing unless VITE_I18N is on. */}
      <LanguageSwitcher />
    </footer>
    </>
  )
}
